import PropTypes from 'prop-types';
import React from 'react';

import { STETHOSCOPE } from 'FRONTEND/utils/constants';

/* eslint-disable max-len */


const ListenableBodyPart = ({
  bodyPart,
  currentSelectedPoint,
  medias,
  setSelectedListeningPoint,
  listeningPointClicked,
}) => {
  const isMediasEmpty = (listeningPoint) => {
    return !medias[listeningPoint];
  };

  // Define class to apply on each selection point.
  const defineClassName = (pointName) => {
    const isPointEmpty = isMediasEmpty(pointName);
    if (currentSelectedPoint === pointName && !isPointEmpty) {
      return 'locationPoint_active hasMedia';
    } else if (currentSelectedPoint === pointName) {
      return 'locationPoint_active';
    } else if (!isPointEmpty) {
      return 'locationPoint hasMedia';
    } else {
      return 'locationPoint';
    }
  };

  const handleCircleClick = (pointName) => {
    if (!isMediasEmpty(pointName)) {
      setSelectedListeningPoint(pointName);
    }
    if (listeningPointClicked) {
      listeningPointClicked(pointName);
    }
  };

  const displayChestArea = () => {
    return (
      <svg className='bodyPart' viewBox='0 0 38.482 37.708' xmlns='http://www.w3.org/2000/svg'>
        <path d='m30.984 23.703-23.367 0.21342c-0.05141 2.0085 0.094568 3.4365 0.094568 3.4365 1.4458 5.2504 1.3737 6.5446 1.1255 10.183h21.191c-0.3272-3.7773-0.44932-5.0306 0.92294-10.395 0 0 0.12016-1.4303 0.03204-3.4375z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m38.183 28.999c-2.6428 1.7823-4.4405 1.3805-6.1888 1.8066-0.75835 0.89543 0.12894 3.6122 1.5477 6.7303h4.7682v-8.4475c-0.04229-0.03168-0.08482-0.06229-0.12712-0.08888z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m0.7027 29.302c-0.1779 0.11588-0.35497 0.28078-0.53072 0.48421v7.7494h5.4069c1.3092-3.0439 2.095-5.6656 1.341-6.5272-1.7549-0.39783-3.5459 0.03304-6.2172-1.7064z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m34.351 7.1132c2.789 2.278 3.6144 5.5884 3.2415 10.861 0.5145 4.3001 0.43942 7.9311 0.59039 11.028-2.6204 1.7752-5.4299 1.5009-6.189 1.8064-0.49375-2.3313-0.79426-3.6626-0.79426-3.6626l0.20812-9.499s-0.02228-12.089 2.9432-10.533z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m4.1805 7.3569c-2.7519 2.3228-3.5236 5.6461-3.0657 10.911-0.44497 4.3078-0.31125 7.9371-0.41218 11.036 2.6487 1.7326 5.4535 1.413 6.2174 1.7062 0.45603-2.339 0.73499-3.675 0.73499-3.675l-0.36153-9.4943s-0.173-12.088-3.113-10.484z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m7.6185 24.405s0.0093-19.021-3.4373-16.926c3.9307-1.7938 8.7372-3.4539 10.755-5.4588 2.4486 1.4924 4.3448 1.3394 4.3448 1.3394s1.5586 0.21047 4.2031-1.4035c2.0468 1.9745 6.91 3.4227 10.866 5.1574-3.4763-2.0432-3.2272 17.114-3.2272 17.114' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.3477' />
        <path d='m10.087 6.7749c1.0204 0.0621 4.6819-1.0144 6.0936 0.87511m12.223-1.0096c-1.0194 0.07707-4.6963-0.94551-6.0801 0.96447' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m31.123 23.751c-0.4582 1.1354-3.7074 3.6634-6.1493 3.7877-5.3447 0.27216-4.1242-4.7108-5.6106-4.717l1e-4 8e-4c-1.4861 0.028-0.19257 4.9925-5.5407 4.7988-2.4435-0.0885-5.7304-2.5768-6.2053-3.7054' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeDasharray='0.343958, 0.343958' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m14.827 0.17198c0.03759 0.53038 0.07872 1.17 0.108 1.8433 0 0 2.1533 1.3613 4.346 1.3141 2.1927-0.04712 4.2034-1.3736 4.2034-1.3736 0.01627-0.64676 0.0038-1.2609-0.01394-1.7839z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m16.258 0.17198c0.72719 0.46973 1.6642 0.79164 2.8531 0.79478 1.1919-0.02259 2.1184-0.33853 2.8308-0.79478z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <circle transform='scale(-1,1)' cx='-26.975' cy='19.118' r='.43934' fill='#d9c863' opacity='.998' paintOrder='stroke fill markers' />
        <circle transform='scale(-1,1)' cx='-11.482' cy='19.228' r='.43934' fill='#d9c863' opacity='.998' paintOrder='stroke fill markers' />
        <circle transform='scale(-1,1)' cx='-19.367' cy='36.797' r='.43934' fill='#d9c863' opacity='.998' paintOrder='stroke fill markers' />
        {/* Circle with listening points */}
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_CHEST_RIGHT + '1'}
          className={defineClassName(STETHOSCOPE.BODY_CHEST_RIGHT + '1')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_CHEST_RIGHT + '1');
          }}
          cx='-13.707' cy='12.988' r='2.1547' paintOrder='stroke fill markers'
        />
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_CHEST_RIGHT + '2'}
          className={defineClassName(STETHOSCOPE.BODY_CHEST_RIGHT + '2')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_CHEST_RIGHT + '2');
          }}
          cx='-19.241' cy='24.055' r='2.1547' paintOrder='stroke fill markers'
        />
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_CHEST_LEFT + '1'}
          className={defineClassName(STETHOSCOPE.BODY_CHEST_LEFT + '1')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_CHEST_LEFT + '1');
          }}
          cx='-24.995' cy='12.656' r='2.1547' paintOrder='stroke fill markers'
        />
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_CHEST_LEFT + '2'}
          className={defineClassName(STETHOSCOPE.BODY_CHEST_LEFT + '2')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_CHEST_LEFT + '2');
          }}
          cx='-27.541' cy='28.039' r='2.1547' paintOrder='stroke fill markers'
        />
      </svg>
    );
  };

  const displayBackArea = () => {
    return (
      <svg className='bodyPart' viewBox='0 0 38.403 37.637' xmlns='http://www.w3.org/2000/svg'>
        <g transform='translate(-74.724 -94.593)'>
          <path transform='matrix(.26458 0 0 .26458 62.905 85.295)' d='m90.693 35.672c0.92645 4.9133 3.2617 12.732 3.2617 12.732s3.1412-2.7135 2.8887 0.06445c-0.25255 2.7779 2.416 9.5313 2.416 9.5313s0.25135 4.5451 0.50391 10.354c0.25255 5.8084-29.295 15.152-40.406 21.213-10.401 8.7791-13.317 21.34-11.586 41.24-1.6818 16.282-1.1771 30-1.5586 41.711-0.34784 0.22656-0.69513 0.50442-1.041 0.82226v3.5488h24.953c1.4239-7.2446 2.3652-11.812 2.3652-11.812l-1.3672-35.885 1.584 35.967c1.2818 4.6548 2.2537 8.5033 2.9922 11.73h81.914c0.69512-3.3905 1.6373-7.4807 2.9297-12.533l0.92578-35.988-0.70898 35.902s1.0789 4.7633 2.7676 12.619h25.789v-3.7461c-0.71457-0.81501-1.4314-1.4655-2.1484-1.9141-0.59549-11.702-0.34123-25.426-2.3203-41.674 1.3668-19.929-1.7784-32.434-12.338-41.021-11.221-5.8568-40.933-14.659-40.787-20.471 0.14635-5.812 0.31445-10.361 0.31445-10.361s2.5455-6.8014 2.2422-9.5742c-0.30328-2.7728 2.8848-0.11914 2.8848-0.11914s2.0617-7.3925 2.9492-12.336z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='1px' />
          <path transform='matrix(.26458 0 0 .26458 62.905 85.295)' d='m187.87 171.37c-5.5545 3.746-10.105 4.9176-14.201 5.5156h15.646v-4.3379c-0.48129-0.47316-0.96293-0.87452-1.4453-1.1777zm-141.66 1.1445c-0.34784 0.22656-0.69513 0.50442-1.041 0.82226v3.5488h10.582c-2.864-0.77621-5.9942-2.0616-9.541-4.3711z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='1px' />
          <path transform='matrix(.26458 0 0 .26458 62.905 85.295)' d='m171.42 88.125c-9.226 0.1742-9.9473 40.242-9.9473 40.242l8e-3 35.99s1.0617 4.7444 2.7188 12.531h9.2051c4.2792-0.71629 9.4625-2.1228 14.471-5.5156-0.57061-11.703-0.28787-25.427-2.2324-41.68 1.4092-19.926-1.7107-32.437-12.252-41.047-0.70051-0.36754-1.3556-0.5331-1.9707-0.52148zm-110.1 0.88867c-0.61517-0.0017-1.2684 0.17393-1.9629 0.55273-10.401 8.7791-13.317 21.34-11.586 41.24-1.6818 16.282-1.1771 30-1.5586 41.711 3.4019 2.2253 6.8659 3.5419 10.078 4.3711h13.834c1.4239-7.2446 2.3652-11.812 2.3652-11.812l-1.3672-35.885s-0.57515-40.153-9.8027-40.178z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='1.002' />
          <path transform='translate(18.377 21.068)' d='m70.988 82.583c1.1343 0.70911 3.0106 1.3809 4.5357 1.4168m4.0123-1.4796c-1.1238 0.72568-2.99 1.425-4.5144 1.4832' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.26458px' />
          <path transform='translate(18.474 20.928)' d='m71.218 94.699s0.15995 2.6976 0.04122 3.256c-0.36072 1.6966-1.2577 1.8978-1.2577 1.8978m9.1135-5.226s-0.11061 2.7001 0.0183 3.2562c0.39167 1.6898 1.2922 1.8745 1.2922 1.8745' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.26458px' />
          <path d='m100.03 94.623-6.6078-0.0303-6.6078 0.0303c1.4549 5.8439 4.083 6.4824 6.6078 6.4824 2.5248 0 5.153-0.63856 6.6078-6.4824z' fill='#000008' opacity='.99' strokeWidth='0' paintOrder='stroke fill markers' />
          {/* Circle with listening points */}
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_LEFT + '1'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_LEFT + '1')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_LEFT + '1');
            }}
            cx='-90.281' cy='110.7' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_LEFT + '2'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_LEFT + '2')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_LEFT + '2');
            }}
            cx='-91.22' cy='116.23' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_LEFT + '3'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_LEFT + '3')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_LEFT + '3');
            }}
            cx='-90.76' cy='121.76' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_LEFT + '4'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_LEFT + '4')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_LEFT + '4');
            }}
            cx='-85.751' cy='126.44' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_RIGHT + '1'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_RIGHT + '1')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_RIGHT + '1');
            }}
            cx='-97.345' cy='110.72' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_RIGHT + '2'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_RIGHT + '2')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_RIGHT + '2');
            }}
            cx='-96.577' cy='116.35' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_RIGHT + '3'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_RIGHT + '3')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_RIGHT + '3');
            }}
            cx='-96.884' cy='121.73' r='2.1547' paintOrder='stroke fill markers'
          />
          <circle
            transform='scale(-1,1)'
            id={STETHOSCOPE.BODY_BACK_RIGHT + '4'}
            className={defineClassName(STETHOSCOPE.BODY_BACK_RIGHT + '4')}
            onClick={() => {
              handleCircleClick(STETHOSCOPE.BODY_BACK_RIGHT + '4');
            }}
            cx='-101.65' cy='126.72' r='2.1547' paintOrder='stroke fill markers'
          />
        </g>
      </svg>
    );
  };

  const displayAbdomenArea = () => {
    return (
      <svg className='bodyPart' viewBox='0 0 38.482 37.708' xmlns='http://www.w3.org/2000/svg'>
        <path d='m19.297 32.192-0.01707 5.3e-4c-4.1348 0.35918-4.1835 2.5883-4.1884 4.7656-5.3e-4 0.20463 0.01902 0.3963 0.05374 0.57774h8.3587c0.04051-0.202 0.06318-0.41636 0.05891-0.64699-0.040293-2.1769-0.12578-4.405-4.2659-4.6969z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m37.997 15.518c-2.6428 1.7823-4.4405 1.3805-6.1888 1.8066-1.555 1.8361 3.745 11.254 6.5019 16.223v-17.785c-0.10429-0.09603-0.20869-0.17825-0.31316-0.24391z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m0.51718 15.821c-0.11547 0.07521-0.23056 0.17233-0.3452 0.28525v18.354c2.5637-4.821 8.2087-15.052 6.5624-16.933-1.7549-0.39783-3.5459 0.033043-6.2172-1.7064z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m31.393 0.17198c-0.17182 2.1512-0.17105 3.9941-0.17105 3.9941l-0.20826 9.4992s0.30052 1.331 0.79427 3.6623c0.7591-0.3055 3.5689-0.03089 6.1893-1.8061-0.15097-3.0969-0.07616-6.7282-0.59066-11.028 0.11432-1.6164 0.11489-3.0468-0.018098-4.3212z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m0.90889 0.17198c-0.14449 1.3501-0.1307 2.8748 0.020672 4.6152-0.44497 4.3078-0.31145 7.9371-0.41238 11.036 2.6487 1.7326 5.4533 1.4126 6.2172 1.7058 0.45603-2.339 0.73536-3.6747 0.73536-3.6747l-0.36173-9.4945s-0.031571-1.9566-0.2558-4.1879z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m6.8708 0.17198h24.461c-0.47157 5.1022-0.46362 10.532-0.46362 10.532 0.01827 1.525-0.10189 2.9556-0.10189 2.9556-1.7263 6.7487-1.092 6.9189-0.65298 13.902-1.0552 0.20943-6.426 5.3815-6.5396 7.7978-0.42603-1.4525-1.4523-3.1515-4.2587-3.1586-2.8064-0.0071-3.7115 1.4663-4.2003 3.2361-0.15781-2.4138-5.6222-7.4868-6.6811-7.6769 0.31131-6.9901 0.94238-7.1719-0.90698-13.888 0 0-0.14628-1.4281-0.094236-2.9668 0 0-3.433e-4 -5.5964-0.56161-10.733z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.35922' />
        <path d='m30.938 10.271c-0.4582 1.1354-3.7074 3.6634-6.1493 3.7877-5.3447 0.27216-4.1242-4.7108-5.6106-4.717l1e-4 8e-4c-1.4861 0.028-0.19257 4.9925-5.5407 4.7988-2.4435-0.0885-5.7294-2.5685-6.2043-3.6971' fill='none' stroke='#d8c863' strokeDasharray='0.343958, 0.34395799999999999' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m30.145 27.617s-1.421 0.67728-2.694 1.8783c-1.8557 1.7508-3.8007 4.3947-3.9149 5.8551 0.11714 0.85967 0.11156 1.5764-0.02945 2.1849h8.6429c-0.06447-0.84748-0.17204-1.6132-0.32918-2.2722-0.56087-2.5549-1.6754-7.646-1.6754-7.646z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <path d='m8.4173 27.82c-0.5821 2.5516-1.051 5.3852-1.5496 7.6715-0.13135 0.59919-0.21771 1.2902-0.26975 2.0443h8.6057c-0.1349-0.58992-0.14836-1.2824-0.05116-2.1084-0.23758-2.4582-5.9016-7.7882-6.7351-7.6074z' fill='#fffbe7' fillOpacity='.98824' stroke='#d8c863' strokeOpacity='.98824' strokeWidth='.34396' />
        <circle transform='scale(-1,1)' cx='-19.268' cy='23.305' r='.43934' fill='#d9c863' opacity='.998' paintOrder='stroke fill markers' />
        <circle transform='scale(-1,1)' cx='-26.806' cy='5.5747' r='.43934' fill='#d9c863' opacity='.998' paintOrder='stroke fill markers' />
        <circle transform='scale(-1,1)' cx='-11.312' cy='5.743' r='.43934' fill='#d9c863' opacity='.998' paintOrder='stroke fill markers' />
        {/* Circle with listening points */}
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_ABDOMEN_RIGHT + '1'}
          className={defineClassName(STETHOSCOPE.BODY_ABDOMEN_RIGHT + '1')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_ABDOMEN_RIGHT + '1');
          }}
          cx='-14.757' cy='19.142' r='2.1547' paintOrder='stroke fill markers'
        />
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_ABDOMEN_RIGHT + '2'}
          className={defineClassName(STETHOSCOPE.BODY_ABDOMEN_RIGHT + '2')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_ABDOMEN_RIGHT + '2');
          }}
          cx='-14.71' cy='26.796' r='2.1547' paintOrder='stroke fill markers'
        />
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_ABDOMEN_LEFT + '1'}
          className={defineClassName(STETHOSCOPE.BODY_ABDOMEN_LEFT + '1')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_ABDOMEN_LEFT + '1');
          }}
          cx='-23.923' cy='19.095' r='2.1547' paintOrder='stroke fill markers'
        />
        <circle
          transform='scale(-1,1)'
          id={STETHOSCOPE.BODY_ABDOMEN_LEFT + '2'}
          className={defineClassName(STETHOSCOPE.BODY_ABDOMEN_LEFT + '2')}
          onClick={() => {
            handleCircleClick(STETHOSCOPE.BODY_ABDOMEN_LEFT + '2');
          }}
          cx='-23.923' cy='26.796' r='2.1547' paintOrder='stroke fill markers'
        />
      </svg>
    );
  };

  return (
    <>
      {bodyPart === STETHOSCOPE.BODY_CHEST && displayChestArea()}
      {bodyPart === STETHOSCOPE.BODY_BACK && displayBackArea()}
      {bodyPart === STETHOSCOPE.BODY_ABDOMEN && displayAbdomenArea()}
    </>
  );
};

ListenableBodyPart.proptypes = {
  bodyPart: PropTypes.string,
  currentSelectedPoint: PropTypes.string,
  medias: PropTypes.object,
  setSelectedListeningPoint: PropTypes.func,
};

ListenableBodyPart.defaultProps = {
  setSelectedListeningPoint: () => {},
};

export default ListenableBodyPart;
